import { render } from "./RejectedOffer.vue?vue&type=template&id=160a5ccc&scoped=true"
import script from "./RejectedOffer.vue?vue&type=script&lang=js"
export * from "./RejectedOffer.vue?vue&type=script&lang=js"

import "./RejectedOffer.vue?vue&type=style&index=0&id=160a5ccc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-160a5ccc"

export default script